import { generateServiceId } from "@core/domains/identity";

export const ACCOUNT_SERVICE = {
  ID: generateServiceId("account"),
  JOB_TYPES: { githubWebhookRelay: "githubWebhookRelay" },
  LABEL: "accounts",
} as const;
